import type { ReactNode } from 'react'
import { Navigate, Outlet } from 'react-router'

import { isAuthenticated } from '@/resources/services/permission/auth'
import AppProvider from '@/contexts'
import RedirectRules from '@/components/business/RedirectRules'

import { OnlinePaymentProvider } from '../contexts/onlinePayment'
import PageLayout from '../components/business/PageLayout'
import SupportChat from '../components/business/SupportChat'

type AuthenticatedRouteProps = {
  children?: ReactNode
}

const AuthenticatedRoute = ({ children }: AuthenticatedRouteProps) => {
  if (!isAuthenticated()) return <Navigate to="/login" />

  return (
    <AppProvider>
      <RedirectRules />
      <OnlinePaymentProvider>
        <PageLayout>
          <SupportChat />
          {children ?? <Outlet />}
        </PageLayout>
      </OnlinePaymentProvider>
    </AppProvider>
  )
}

export default AuthenticatedRoute
